
import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { ControlContainer, FormGroupDirective, ReactiveFormsModule, FormGroup } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { TypedForm } from '@modules/shared/interfaces/typed-form/typed-form';
import { TrafficDeviationForm } from '@components/traffic-deviations/interfaces/traffic-deviation-form';
import { ValidationMessageComponent } from '../validation-message/validation-message.component';

@Component({
    selector: 'app-internal-comment',
    imports: [
    ReactiveFormsModule,
    TranslateModule,
    ValidationMessageComponent
],
    templateUrl: './internal-comment.component.html',
    viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }],
    styleUrls: ['./internal-comment.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class InternalCommentComponent implements OnInit {
  private readonly _formGroupDirective = inject(FormGroupDirective);

  protected _parentForm: FormGroup<TypedForm<TrafficDeviationForm>>;

  ngOnInit(): void {
    this._parentForm = this._formGroupDirective.form;
  }

}